import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "clickable-bar-tooltip",
  templateUrl: "./clickable-bar-tooltip.component.html",
  styleUrls: ["./clickable-bar-tooltip.component.scss"],
})
export class ClickableBarTooltipComponent implements OnInit {
  @Input() y: number;
  @Input() name: string;
  @Input() prefix: string;
  @Input() suffix: string;
  @Input() color: string;
  @Input() numerator: number;
  @Input() denominator: number;
  @Input() descriptor: string;
  @Input() subtitle: string;
  constructor() {}

  ngOnInit() {}
}
